import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import '../../styles/core.scss';
import css from './editable-text-box.scss';
import { forceRender } from '../../helpers/utils';

/* global document */

@styleable(css)
class EditableTextBox extends Component {
  static propTypes= {
      children: PropTypes.string,
      textData: PropTypes.string,
      holderData: PropTypes.object,
      receiveCharsUpdate: PropTypes.func,
      passwordRevertNoticer: PropTypes.object
  };

  constructor(props) {
      super(props);
      const textNode = this.props.textData || this.props.children;
      this.textEmptyWarnig = 'type ...';
      const text = (typeof textNode === 'string') ? textNode : this.textEmptyWarnig;
      this.textBackup = text;
      this.textDidUpdate = false;
      this.state = { text, beEditor: false };
      this.toSaveChanges = false;

      this.onLabelClick = this.onLabelClick.bind(this);
      this.onInputChange = this.onInputChange.bind(this);
      this.onInputClick = this.onInputClick.bind(this);
      this.allDisplayLabel = this.allDisplayLabel.bind(this);

      this.onInputKeydown = this.onInputKeydown.bind(this);
      this.onCancelPostInput = this.onCancelPostInput.bind(this);

      this.populateCharUpdate = this.populateCharUpdate.bind(this);

      this.passwordRevertBack = this.passwordRevertBack.bind(this);

      this.isMyselfClick = false;
      this.subscribeMounted = false;
  }

  componentWillUpdate() {} // Not use this, as this is to be deprecated in higher react version.

  componentDidMount() {
      this.subscribeMounted = true;

      document.addEventListener('click', this.allDisplayLabel);
      // below is only used for trouble shooting in IE.
      this.safeEmptyText = (isIE()) ? ' ' : '';
  }

  componentDidUpdate(prevProps /* , prevState, snapshot */) {
      // save item that is to be saved first before update it.
      if (this.toSaveChanges && prevProps !== this.props) {
          const { text } = this.state;
          const textTrimed = (text || '').trim();
          const { holderData } = prevProps;
          this.populateCharUpdate(textTrimed, holderData);
      }
      // textData is for inject data to props, prevProps.children is for the case to receive child text node update.
      const prevTextNode = prevProps.textData || prevProps.children;
      const prevText = (typeof prevTextNode === 'string') ? prevTextNode : this.textEmptyWarnig;

      const textNode = this.props.textData || this.props.children;
      const text = (typeof textNode === 'string') ? textNode : this.textEmptyWarnig;

      // prevText !== this.textBackup
      if (prevText !== text && this.subscribeMounted && prevProps !== this.props) {
          this.textBackup = text;
          this.textDidUpdate = text;
      }
  }

  componentWillUnmount() {
      this.subscribeMounted = false;

      const { passwordRevertNoticer } = this.props;
      if (passwordRevertNoticer) {
          passwordRevertNoticer.inform = undefined;
      }
  }

  passwordRevertBack() {
      const text = this.textBackup;
      const textTrimed = (text || '').trim();
      if (this.subscribeMounted) {
          this.setState({ text: textTrimed, beEditor: false });
      }
  }

  onLabelClick(/* event */) {
      // event.stopPropagation();
      this.isMyselfClick = true;
      const { text } = this.state;
      let displayText = this.textDidUpdate || text;
      displayText = displayText || this.safeEmptyText;
      this.textDidUpdate = false; // finished updated, no more need now, until next update cycle.
      if (this.subscribeMounted) {
          this.setState({ text: displayText, beEditor: true });
      }

      const { passwordRevertNoticer } = this.props;
      if (passwordRevertNoticer) {
          passwordRevertNoticer.inform = this.passwordRevertBack;
      }
      this.toSaveChanges = true;
  }

  populateCharUpdate(text, holder) {
      // added some rules if required later
      const { receiveCharsUpdate } = this.props;
      if (typeof receiveCharsUpdate === 'function' && text !== this.textBackup && this.toSaveChanges) {
          receiveCharsUpdate(text, holder);
      }
      this.toSaveChanges = false;
  }

  onInputChange(event) {
      // // event order: 3
      if (this.startInputKeydown === true && this.subscribeMounted) {
          const text = event.target.value;
          this.setState({ text, beEditor: true });
      }

      this.startInputKeydown = false;
      // console.log('onInputChange 3');
      if (isMobile) {
          forceRender();
      }
  }

  onInputClick(/* event */) {
      // event.stopPropagation();
      this.isMyselfClick = true;
  }

  // this is maily for windows browser, plus handle 'return' for closing editor.
  onInputKeydown(event) {
      this.startInputKeydown = true;
      this.toSaveChanges = true;
      // event order: 1
      // console.log('onInputKeydown 1');
      // event.stopPropagation();
      // e.nativeEvent.stopImmediatePropagation();
      if (event.key === 'Enter' || event.keyCode === 13) {
          const { text } = this.state;
          let textTrimed = (text || '').trim();
          this.populateCharUpdate(textTrimed);
          if (text === '') {
              textTrimed = this.textDidUpdate || this.textBackup; // this logic is the same as "passwordRevertBack"
          }
          if (this.subscribeMounted) {
              this.setState({ text: textTrimed, beEditor: false });
          }
      }
  }

  // this is maily for windows browser, trouble shooting for its none-standard event handling.
  onCancelPostInput(/* event */) {
      // event order: 2
      // console.log('onCancelPostInput 2');
      // const { text } = this.state;
      const text = this.textBackup;
      if (this.startInputKeydown !== true && this.isMyselfClick !== true) {
          const textTrimed = (text || '').trim();
          // this.populateCharUpdate(textTrimed);
          if (this.subscribeMounted) {
              this.setState({ text: textTrimed, beEditor: false });
          }
      }
  }

  allDisplayLabel(/* event */) {
      if (this.isMyselfClick !== true) {
          const { text, beEditor } = this.state;
          if (beEditor === true && this.subscribeMounted) {
              let textTrimed = (text || '').trim();
              this.populateCharUpdate(textTrimed);
              if (text === '') {
                  textTrimed = this.textDidUpdate || this.textBackup; // this logic is the same as "passwordRevertBack"
              }
              this.setState({ text: textTrimed, beEditor: false });

              // not sure comment out this will not sensitive enough (more effectively response to
              // disable edit-functionality), need have look it to get good reason.
              // event.stopPropagation();
              // event.stopImmediatePropagation();
          }
      }

      this.isMyselfClick = false;
  }

  render() {
      const { text, beEditor } = this.state;
      const { textData } = this.props;
      // textData vs textBackup - "equal" means text should be from text, "not-equal" means from outside just now.
      // textDidUpdate false vs 'string' - false means use editor data, otherwise use updated text;
      let displayText = (textData === this.textBackup) ? (this.textDidUpdate || text) : textData;

      displayText = displayText || this.textEmptyWarnig;
      const currentDisplayMode = beEditor ? (
          <input
              type="text"
              value={text}
              placeholder={this.textEmptyWarnig}
              onChange={this.onInputChange}
              onClick={this.onInputClick}
              className={css['input-dim']}
              onInput={this.onCancelPostInput}
              onKeyDown={this.onInputKeydown} />
      ) : (
          <div role="button" tabIndex={-1} onClick={this.onLabelClick} className={css['label-dim']}>{displayText}</div>
      );
      return (
          <div className={css['editable-text-box']} >
              {currentDisplayMode}
          </div>
      );
  }
}

// this is only used for trouble shooting to debug IE event issue, not being followed standard event type requirement.
function isIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    return false;
}

export default EditableTextBox;



// WEBPACK FOOTER //
// ./components/editable-text-box/editable-text-box.js